import ToggleSwitch from "./ToggleSwitch";

type Props = {
  label: string;
  required?: boolean;
  enabled?: boolean;
  onToggle?: (val: boolean) => void;
  children: React.ReactNode;
};

export default function SectionBox({ label, required, enabled, onToggle, children }: Props) {
  const show = required || !!enabled;
  return (
    <div className="tw-border tw-border-gray-200 tw-rounded-xl tw-overflow-hidden">
      <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-bg-gray-50">
        <span className="tw-text-sm tw-font-semibold tw-text-gray-800">
          {label}
          {!required ? (
            <span className="tw-text-xs tw-text-gray-400 tw-font-normal tw-ml-1.5">(선택)</span>
          ) : null}
        </span>
        {!required && onToggle && (
          <ToggleSwitch checked={!!enabled} onChange={onToggle} />
        )}
      </div>
      {show && (
        <div className="tw-p-4 tw-border-t tw-border-gray-200 tw-space-y-3">
          {children}
        </div>
      )}
    </div>
  );
}
